module.exports = new __parcel__URL__("titan3.605740d6.png").toString();